interface CalculateProps {
  height: number;
  unitMeasureHeight: string;
  unitMeasureWeight: string;
  weight: number;
}

export default class CalculateIMC {

  private static calculateHeight(unitMeasureHeight: string, height: number): number | null {
    switch (unitMeasureHeight) {
      case 'cm':
        return height / 100;
      case 'm':
        return height;
      default:
        return null;
    }
  }

  private static calculateWeight(unitMeasureWeight: string, weight: number): number | null {
    switch (unitMeasureWeight) {
      case 'Kg':
        return weight;
      case 'g':
        return weight / 1000;
      default:
        return null;
    }
  }

  public static calculate({
    height,
    unitMeasureHeight,
    unitMeasureWeight,
    weight
  }: CalculateProps): number | undefined {
    if (!(height > 0) || !(weight > 0)) {
      return undefined
    }

    const validatedHeight = this.calculateHeight(unitMeasureHeight, height);
    const validatedWeight = this.calculateWeight(unitMeasureWeight, weight);

    return Number(validatedWeight) / (Number(validatedHeight) * Number(validatedHeight));
  }
}
